import React, { Component } from "react";
import { GetUser, ShrinkNumber } from "../util/Helper";
import ImageOrInitial from "./ImageOrInitial";
import html2canvas from 'html2canvas';
import { jsPDF } from 'jspdf';
import {deletePolicy } from "../services/BinderDropService";
import PolicyDetailsPopup from "../popups/PolicyDetailsPopup";
import moment from "moment";
class Tower extends Component {
  constructor(props) {
      super(props);
      this.state = {
        showPolicyPopup:false,
        activePolicy:{},
        pdf:{},
      };
      this.printRef = React.createRef();
  }

  componentDidMount() {
    //this.setState({user:GetUser()});
  }

  

  handleDownloadPdf = async () => {
    const element = this.printRef.current;
    const canvas = await html2canvas(element);
    const data = canvas.toDataURL('image/png');

    const pdf = new jsPDF();
    const imgProperties = pdf.getImageProperties(data);
    const pdfWidth = pdf.internal.pageSize.getWidth();
    const pdfHeight =
      (imgProperties.height * pdfWidth) / imgProperties.width;

    pdf.addImage(data, 'PNG', 0, 0, pdfWidth, pdfHeight);
    pdf.save(this.props.tower.company.name.toLowerCase().replace(/\s+/g, '_')+moment(this.props.tower.effectiveDate).format('MMYY')+"-"+moment(this.props.tower.expirationDate).format('MMYY')+'.pdf');
  };

  policyPopupClose = (updated) =>{
    this.setState({showPolicyPopup:false, activePolicy:{}, pdf:{}});

    if(updated){
      if(this.props.refreshTower){
        this.props.refreshTower();
      }
    }
  }

  deletePolicy = (policy) => {
    deletePolicy(policy).then((tower) => {
      if(this.props.refreshTower){
        this.props.refreshTower();
      }
    });
  }

  render() {
    this.props.tower?.policies?.sort((a,b) => b.liabilityStartThreshold - a.liabilityStartThreshold); 
    var _hasA = false;
    var _hasABC = false;


    if(!this.props.tower){
      return (<div className="card fullTable"></div>);
    }

    this.props.tower.policies.forEach(p => {
      if(p.type.indexOf("Lead Side A") > -1) _hasA = true;
      if(p.type.indexOf("A/B/C") > -1 || p.type.indexOf("ABC") > -1) _hasABC = true;
    });

    return (
      <div>
        <div className="cardRow">
        <label className="sectionTitle sectionTitleWithOptions">{this.props.title || "Tower Details"}</label>
        {!this.props.editing && 
        <>
        <a type="button" href={"/tower?id="+this.props.tower.towerId} className="pillButton sectionTitlePB">
          Update Tower 
        </a>
        <a type="button" onClick={this.handleDownloadPdf} className="pillButton sectionTitlePB">
          Download as PDF 
        </a>
        </>
        }
        </div>
        <div className="card fullTable" ref={this.printRef}>
          
          <div className="tableRow">
            <div className="towerHeader"/>
            <span className="thStats">Rate Per $M</span>
            <span className="thStats">Inc. Limit Factor</span>
            
          </div>
          {this.props.tower.policies.map((policy, index) => {

              if(!policy.increasedRateFactor && this.props.tower.policies[index+1] && policy.type.indexOf("Lead Side A") == -1){
                policy.increasedRateFactor = Math.round(policy.premiumPerMillion / this.props.tower.policies[index+1].premiumPerMillion * 100);
              }
              var _visualClass = "towerVisual";
              if(policy.type.indexOf("Primary") > -1 || policy.type.indexOf("Lead Side A") > -1) _visualClass += " towerVisualPrimary";
              if(policy.type.indexOf("A/B/C") > -1 || policy.type.indexOf("ABC") > -1 || policy.type ==="Primary") _visualClass += " towerVisualABC";
              
              return  <div key={'policy'+policy.policyId} className="tableRow">
                        <div className={_visualClass}>
                          <a href={"/insurers?id="+policy.insurer.insurerId} className="tvInsurer">{policy.insurer?.name}</a>
                          <span><b>Limit:</b> {(policy.liabilityStartThreshold ? "$" : "Primary $") + ShrinkNumber(policy.liabilityLimit)} {policy.liabilityStartThreshold ? ("excess of $"+ShrinkNumber(policy.liabilityStartThreshold)):""}</span>
                          <span><b>Premium:</b> {"$" + ShrinkNumber(policy.premium)}</span>
                        </div>
                        <span className="tvStats">${ShrinkNumber(policy.premiumPerMillion)}</span>
                        <span className="tvStats">{policy.increasedRateFactor ?  (policy.increasedRateFactor+"%") : "--"}</span>
                        {this.props.editing && 
                        <div className="tvUpdateContainer">
                        <button className="pillButton tvUpdateButton"  onClick={() => this.setState({showPolicyPopup:true, activePolicy:policy, pdf:policy.pdf})}>Update</button>
                        <button className="pillButton tvDeleteButton"  onClick={() => this.deletePolicy(policy)}>Delete</button>
                        </div>
                        }
                      </div>

          })}

          <div className="towerLegend">
            {_hasA &&
            <div>
              <span className="tlA">Side A</span>
              <span className="tlA towerVisualPrimary">{_hasABC ? "Lead Side A" :"Primary"}</span>
            </div>
            }
            {_hasABC &&
            <div>
              <span className="tlABC">Excess ABC</span>
              <span className="tlABC towerVisualPrimary">Primary</span>
            </div>
            }
          </div>
      </div>
      <PolicyDetailsPopup update pdf={this.state.pdf} policy={this.state.activePolicy} open={this.state.showPolicyPopup} onClose={this.policyPopupClose}/>
    </div>
    );
  }
}
 
export default Tower;